import {isFerryRoute} from "@Route/features/transportType/functions/isFerryRoute";
import {isPrivateBusRoute} from "@Route/features/transportType/functions/isPrivateBusRoute";
import {isMinivanRoute} from "@Route/features/transportType/functions/isMinivanRoute";
import useIsMobile from "@Hooks/selector/useIsMobile";
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import SuggestedRouteType from "@Route/types/SuggestedRoute.type";
import usePassengers from "@Hooks/selector/usePassengers";

export default function useShowLeftStatusBadges(route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType) {
    const isMobile = useIsMobile()
    const passengers = usePassengers()

    const {
        status: {
            hasMTicket,
        },
        allotment: {
            totalAllotmentLeft,
        },
        travelInfo: {
            departureStation: {
                departureDate,
            },
            destinationStation: {
                arrivalDate,
            },
            seatClass,
        },
        type,
    } = route

    const getShowOvernightTravel = () => {
        const showOvernightTravel = (totalAllotmentLeft - passengers.passengers) > 10
        const overnightTravel = departureDate !== arrivalDate

        return showOvernightTravel && overnightTravel
    }

    return {
        showMTicketBadge: hasMTicket && isMobile,
        showMinivanBadge: isMinivanRoute(type.routeTransferType),
        showPrivateBusBadge: isPrivateBusRoute(type.routeTransferType),
        showFerryTypeBadge: isFerryRoute(type.vehicleType, type.routeTransferType),
        showCombinedSeatClassBadge: seatClass?.isCombinedTransportTypeRoute,
        showOvernightTravelBadge: getShowOvernightTravel(),
    }
}